import useSWRImmutable from 'swr/immutable'

import { useApis } from '../contexts/api-context'

const useOwnTherapistData = (therapistUserId: number) => {
  const { api } = useApis()

  const { data, error, mutate, isLoading } = useSWRImmutable(
    therapistUserId ? ['useOwnTherapistData', therapistUserId] : null,
    async () => {
      const res = await api.getTherapistData(therapistUserId)
      return res.data
    },
  )

  return {
    therapistData: data,
    error,
    refetchOwnTherapistData: mutate,
    isLoading,
  }
}

export default useOwnTherapistData
